module.exports = __webpack_public_path__ + "media/assets/google-sign-in-8acda7f23345877f18f0ec5dd8672846.svg";